import script from "./DischargeHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./DischargeHeader.vue?vue&type=script&setup=true&lang=js"

import "./DischargeHeader.vue?vue&type=style&index=0&id=1e0374c9&lang=css"

const __exports__ = script;

export default __exports__